import { APIModel } from "app/state/api";
import { CMSApiCallModel } from "../../interfaces";

const pagesExplorerOrganisation: CMSApiCallModel = {
  ...APIModel(`${process.env.REACT_APP_CMS_API}/pages-explorer-organisation`),
};

export default pagesExplorerOrganisation;
